"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('nasal', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M16.9873 4.00049C17.1078 10.2505 16.7844 14.5869 16.017 17.0096C14.866 20.6438 6.08185 30.7633 6.08185 36.1025C6.08185 41.4416 12.3864 44.3896 15.7906 42.3791",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M32.0014 4.00049C31.7767 10.2505 32.048 14.5869 32.8153 17.0096C33.9663 20.6438 42.9584 29.4501 42.9584 35.2929C42.9584 41.1357 36.446 44.3896 33.0417 42.3791",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M13.0057 34.8341C14.7151 33.8619 16.2017 33.8619 17.4655 34.8341C19.3612 36.2925 19.9561 40.0005 24.0083 40.0005C28.0605 40.0005 30.047 35.8431 32 34.8341C33.302 34.1615 34.6353 34.1615 36 34.8341",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M20.2849 22.146C19.4911 23.0005 18.6511 23.9536 18.0378 25.6143C17.5729 26.8731 17.48 27.6031 17.4157 28.4244",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }));
});

exports.default = _default;